// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinner":"Spinner-module__loadingSpinner___1mk5C","spinner":"Spinner-module__spinner___pzCum"};